<template>
  <error-boundary module="last-module">
    <hr-module class="last-module" blue no-header logo>
      <hr-module-header :title="t('last-module:title')"></hr-module-header>

      <h-r-module-section class="last-module__description">
        {{ t(`last-module:description`) }}
      </h-r-module-section>

      <h-r-module-section>
        <div class="last-module__image">
          <img src="../../static/images/thankyou@2x.png" />
        </div>
      </h-r-module-section>

      <h-r-module-section>
        <div class="last-module__stores">
          <div v-if="!state.browser || state.browser === 'android'">
            <img
              src="../../static/images/google-play.svg"
              @click="goToPlayStore"
            />
          </div>
          <div v-if="!state.browser || state.browser === 'ios'">
            <img
              src="../../static/images/app-store.svg"
              @click="goToAppStore"
            />
          </div>
        </div>
      </h-r-module-section>
    </hr-module>
  </error-boundary>
</template>

<script>
import HrModule from '@/components/hr-module';
import HRModuleSection from '@/components/HRModuleSection';
import HrModuleHeader from '@/components/hr-module-header.vue';
import mobileBrowserDetection from '@/lib/mobile-browser-detection';
import t from '@/lib/i18next';
import ErrorBoundary from '@/components/error-boundary.vue';

export default {
  name: 'last-module',
  components: { ErrorBoundary, HrModule, HrModuleHeader, HRModuleSection },
  setup() {
    const state = {
      browser: mobileBrowserDetection(),
    };

    function goToAppStore() {
      window.open(
        'https://itunes.apple.com/au/app/deputy-roster-shift-planner/id477070330?mt=8',
        '_blank'
      );
    }

    function goToPlayStore() {
      window.open(
        'https://play.google.com/store/apps/details?id=com.deputy.android',
        '_blank'
      );
    }

    return {
      t,
      state,
      goToAppStore,
      goToPlayStore,
    };
  },
};
</script>

<style>
.last-module__image img {
  max-width: 500px;
  margin: 18px 0;
}

.last-module__stores {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.last-module__stores div {
  margin: 0 2px;
}

.last-module__description {
  font-size: 18px;
  max-width: 750px;
  color: #6c6a72;
}

@media screen and (max-width: 787px) {
  .last-module__image img {
    max-height: initial;
    width: 100%;
  }
}
</style>
